import axios from "axios";

import myConfig from "../configs/config";
import { buildPlotName } from "./mapMeasurements";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

function normalizeList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export async function fetchFarmMapLines(farmId) {
  const response = await axios.get(`${myConfig.API_URL}/farm-map-line/`, {
    params: { farm_id: farmId },
    headers: authHeaders(),
  });
  return normalizeList(response.data);
}

export async function saveFarmMapLine({ farmId, name, pathWkt, lengthM }) {
  const response = await axios.post(
    `${myConfig.API_URL}/farm-map-line/`,
    {
      farm: parseInt(farmId, 10),
      name: name || "",
      path: pathWkt,
      length_m: lengthM,
    },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function deleteCropArea(landplotId, farmId) {
  await axios.delete(`${myConfig.API_URL}/landplot/${landplotId}/`, {
    params: farmId ? { farm_id: farmId } : undefined,
    headers: authHeaders(),
  });
}

export async function deleteFarmMapLine(lineId, farmId) {
  await axios.delete(`${myConfig.API_URL}/farm-map-line/${lineId}/`, {
    params: farmId ? { farm_id: farmId } : undefined,
    headers: authHeaders(),
  });
}

export async function saveCropArea({ farmId, cropName, polygonWkt, areaHa }) {
  const trimmedCropName = (cropName || "").trim();
  await axios.post(
    `${myConfig.API_URL}/landplot/?farm_id=${farmId}`,
    {
      farm: parseInt(farmId, 10),
      name: buildPlotName(trimmedCropName, areaHa),
      crop_name: trimmedCropName,
      highlight_on_farm_map: true,
      area: polygonWkt,
    },
    { headers: authHeaders() }
  );

  const crops = await fetchFarmCropAreas(farmId);
  const saved = crops
    .filter((item) => (item.crop_name || "").trim() === trimmedCropName)
    .sort((a, b) => b.id - a.id)[0];

  if (!saved) {
    return null;
  }

  const normalizedName = buildPlotName(trimmedCropName, saved.area_h2);
  if ((saved.name || "").trim() !== normalizedName) {
    try {
      await updateCropAreaName(saved.id, {
        cropName: trimmedCropName,
        areaHa: saved.area_h2,
      });
    } catch (error) {
      // Talhão já foi salvo; falha ao sincronizar o nome não deve bloquear o fluxo.
    }
  }

  return saved;
}

export async function updateCropAreaName(landplotId, { cropName, areaHa }) {
  const normalizedName = buildPlotName(cropName, areaHa);
  const response = await axios.patch(
    `${myConfig.API_URL}/landplot/${landplotId}/`,
    {
      name: normalizedName,
      crop_name: (cropName || "").trim(),
    },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function updateCropAreaGeometry(
  landplotId,
  { farmId, cropName, polygonWkt, areaHa }
) {
  const trimmedCropName = (cropName || "").trim();
  const response = await axios.patch(
    `${myConfig.API_URL}/landplot/${landplotId}/`,
    {
      name: buildPlotName(trimmedCropName, areaHa),
      crop_name: trimmedCropName,
      area: polygonWkt,
      highlight_on_farm_map: true,
    },
    {
      headers: authHeaders(),
      params: farmId ? { farm_id: farmId } : undefined,
    }
  );
  return response.data;
}

export async function fetchFarmCropAreas(farmId) {
  const response = await axios.get(`${myConfig.API_URL}/landplot/`, {
    params: { farm_id: farmId },
    headers: authHeaders(),
  });
  return normalizeList(response.data);
}
